import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { ChartsIcon } from "shared-components/Components/CustomIcons/ChartsIcon/web";
import { TagsIcon } from "shared-components/Components/CustomIcons/TagsIcon/web";
import { FlagsIcon } from "shared-components/Components/CustomIcons/FlagsIcon/web";
import { Col, Row, Skeleton, Space, Typography } from "antd";

import React from "react";
import { useBigDataSingleProp } from "./hook";
import { useTheme } from "../../../Styles/ThemeHook";

import "./styles.less";

const { Text, Title, Paragraph } = Typography;

export const BigDataSingleProp = ({ id }) => {
	const {
		loading,
		error,
		bigData,
		propData,
		offsetData,
		currencySymbol,
		operation,
		show,
	} = useBigDataSingleProp({ property_id: id });
	const { theme } = useTheme();

	if (error || !show) return null;

	return (
		<Row
			gutter={[theme.spacing.lgSpacing, theme.spacing.lgSpacing]}
			className="biddata-single-prop">
			<Col xs={24}>
				<Title level={4}>{"Esta propiedad en números"}</Title>
			</Col>
			{loading ? (
				[1, 2, 3].map((e, i) => (
					<Col xs={24} md={8} key={i}>
						<Skeleton active avatar />
					</Col>
				))
			) : (
				<>
					<Col xs={24} md={8}>
						<Space align={"start"} size="middle">
							<Paragraph>
								<Title level={4}>
									<ChartsIcon />
								</Title>
							</Paragraph>
							<Paragraph>
								<Title level={4}>{propData?.price_m2_text} /m²</Title>
								<Text>
									{`Precio promedio por m² de propiedades similares`}:{" "}
									{bigData?.avg_price_m2_text} /m²
								</Text>
								<Text className="text" strong>
									{offsetData.price_m2 < -4 && (
										<>
											{offsetData.price_m2}% {`por debajo`}
											<ArrowDownOutlined className="success-icon" />
										</>
									)}
									{offsetData.price_m2 > 4 && (
										<>
											{offsetData.price_m2}% {`por arriba`}
											<ArrowUpOutlined className="error-icon" />
										</>
									)}
									{offsetData.price_m2 >= -4 && offsetData.price_m2 <= 4 && (
										<>{`Dentro del promedio`}.</>
									)}
								</Text>
							</Paragraph>
						</Space>
					</Col>

					<Col xs={24} md={8}>
						<Space align={"start"} size="middle">
							<Paragraph>
								<Title level={4}>
									<TagsIcon />
								</Title>
							</Paragraph>
							<Paragraph>
								<Title level={4}>{propData.price_text}</Title>
								<Text>
									{ `Precio de ${String( operation ).toLowerCase()} para propiedades similares` }
									: {bigData?.avg_price_text}
									<br />
								</Text>
								<Text strong className="text">
									{offsetData.price < -4 && (
										<>
											{offsetData.price}% {`por debajo`}
											<ArrowDownOutlined className="success-icon" />
										</>
									)}
									{offsetData.price > 4 && (
										<>
											{offsetData.price}% {`por arriba`}
											<ArrowUpOutlined className="error-icon" />
										</>
									)}
									{offsetData.price >= -4 && offsetData.price <= 4 && (
										<>{`Dentro del promedio`}.</>
									)}
								</Text>
							</Paragraph>
						</Space>
					</Col>

					<Col xs={24} md={8}>
						<Space align={"start"} size="middle">
							<Paragraph>
								<Title level={4}>
									<FlagsIcon />
								</Title>
							</Paragraph>
							<Paragraph>
								<Title level={4}>
									{Math.round(propData.time_in_market / 30)} {`meses`}
								</Title>
								<Text>
									{`Tiempo promedio de publicación de propiedades similares`}:{" "}
									{Math.round(bigData?.avg_time_in_market / 30)} {`meses`}
									<br />
								</Text>
								<Text strong className="text">
									{offsetData.time_in_market < -4 && (
										<>
											{offsetData.time_in_market}% {`por debajo`}
											<ArrowDownOutlined className="success-icon" />
										</>
									)}
									{offsetData.time_in_market > 4 && (
										<>
											{offsetData.time_in_market}% {`por arriba`}
											<ArrowUpOutlined className="error-icon" />
										</>
									)}
									{offsetData.time_in_market >= -4 &&
										offsetData.time_in_market <= 4 && (
											<>{`Dentro del promedio`}.</>
										)}
								</Text>
							</Paragraph>
						</Space>
					</Col>
				</>
			)}
		</Row>
	);
};
